import format from 'date-fns/format';
import parse from 'date-fns/parse';
import BrowserStorage from '../Helpers/BrowserStorage';
import { generateUUID, spendData } from '../Requests/AppRequests';
import SHA256 from '../Helpers/sha256';
import { b64DecodeUnicode } from './b64DecodeUnicode';

const encode = function (s) {
  const e = new Uint8Array(s.length);
  for (let i = 0; i < s.length; i += 1) {
    e[i] = s.charCodeAt(i);
  }
  return e;
};

export const hasProperty = Object.prototype.hasOwnProperty;

export const firstCharToUpperCase = (word) => word.charAt(0).toUpperCase() + word.slice(1);

export function fixScriptsSoTheyAreExecuted(el) {
  const scripts = el.querySelectorAll('script, noscript');
  const fixedScripts = [];
  const len = scripts.length;
  for (let i = 0; i < len; i += 1) {
    const script = scripts[i];
    if (script.tagName === 'SCRIPT') {
      const fixedScript = document.createElement('script');
      if (script.type) { fixedScript.type = script.type; }
      if (script.innerHTML) fixedScript.innerHTML = script.innerHTML;
      else fixedScript.src = script.src;
      Object.keys(script.attributes)
        .map((key) => ({
          name: script.attributes[key].nodeName,
          value: script.attributes[key].nodeValue,
        }))
        .forEach(({ name, value }) => {
          fixedScript.setAttribute(name, value);
        });
      fixedScript.async = false;
      fixedScripts.push(fixedScript);
    } else if (script.tagName === 'NOSCRIPT') {
      const fixedNoScript = document.createElement('noscript');
      fixedNoScript.innerHTML = el.body.innerHTML;
      fixedScripts.push(fixedNoScript);
    }
  }
  return fixedScripts;
}

export function createIframes(el) {
  const iframes = el.querySelectorAll('iframe');
  const fixedIframes = [];
  const len = iframes.length;
  for (let i = 0; i < len; i += 1) {
    const iframe = iframes[i];
    const fixedIframe = document.createElement('iframe');
    if (iframe.innerHTML) fixedIframe.innerHTML = iframe.innerHTML;
    fixedIframe.src = iframe.src;
    Object.keys(iframe.attributes)
      .map((key) => ({
        name: iframe.attributes[key].nodeName,
        value: iframe.attributes[key].nodeValue,
      }))
      .forEach(({ name, value }) => {
        fixedIframe.setAttribute(name, value);
      });
    fixedIframes.push(fixedIframe);
  }
  return fixedIframes;
}

export const generateNewUUID = async () => {
  try {
    const { data } = await generateUUID();
    return data.uuid;
  } catch (e) {
    console.error(e.message);
    return '';
  }
};

export function getUIDFromLocalStorage(defaultUID, uuidOverride = '') {
  let uidFromStorage = BrowserStorage.getFromLocalStorage('uuidASR', false);
  if (!uidFromStorage || uidFromStorage === 'undefined' || uidFromStorage === 'null') {
    uidFromStorage = defaultUID;
  }
  if (uuidOverride && uuidOverride !== 'null' && uuidOverride !== 'undefined') {
    uidFromStorage = uuidOverride;
  }
  BrowserStorage.saveToLocalStorage('uuidASR', uidFromStorage);
  return uidFromStorage;
}

export function getAffidFromLocalStorage() {
  const affidFromStorage = BrowserStorage.getFromLocalStorage('affidASR', false);
  if (!affidFromStorage) {
    return '0';
  }
  return affidFromStorage;
}

const getFormByName = (formInUrl, formsObject) => {
  let formFromObject;
  Object.values(formsObject).map((formObject) => {
    const { formName } = formObject;
    const strippedFormInUrl = formInUrl.toString().split(' ').join('').toLowerCase();
    const strippedFormInObject = formName.toString().split(' ').join('').toLowerCase();
    if (strippedFormInUrl === strippedFormInObject) {
      formFromObject = formObject;
    }
    return formFromObject;
  });
  return formFromObject;
};

const getFormByVariant = (formInUrl, variantInUrl, formsObject) => {
  let formFromObject;
  Object.values(formsObject).map((formObject) => {
    const { formFromUrl, variantFromUrl } = formObject;
    const urlFormNumber = formInUrl.toString().split(' ').join('').toLowerCase();
    const urlVariantNumber = variantInUrl.toString().split(' ').join('').toLowerCase();
    const objectFormNumber = formFromUrl.toString().split(' ').join('').toLowerCase();
    const variantFormNumber = variantFromUrl.toString().split(' ').join('').toLowerCase();
    if (urlFormNumber === objectFormNumber && urlVariantNumber === variantFormNumber) {
      formFromObject = formObject;
    }
    return formFromObject;
  });
  return formFromObject;
};

const getDefaultForm = (formsObject) => {
  let formFromObject;
  Object.values(formsObject).map((formObject) => {
    const { default: defaultForm } = formObject;
    if (defaultForm) {
      formFromObject = formObject;
    }
    return formFromObject;
  });
  return formFromObject;
};

export function selectVariantByForm(formInUrl, variantInUrl, formsObject, defaultForm = false, defaultVariant = false) {
  let formFromUrl = formInUrl || defaultForm || '1000';
  let variantFromUrl = variantInUrl || defaultVariant || '1';
  let formFromObject = formsObject[formInUrl];
  if (!formFromObject) {
    formFromObject = getFormByName(formInUrl, formsObject);
  }
  if (!formFromObject && variantInUrl) {
    formFromObject = getFormByVariant(formInUrl, variantInUrl, formsObject);
  }
  if (!formFromObject) {
    formFromObject = getDefaultForm(formsObject);
  }
  if (!formFromObject && defaultForm && formsObject[defaultForm]) {
    formFromObject = formsObject[defaultForm];
  }
  if (formFromObject && formFromObject.formFromUrl) {
    formFromUrl = formFromObject.formFromUrl;
    variantFromUrl = formFromObject.variantFromUrl;
  }
  return [formFromUrl, variantFromUrl];
}

export const getSpendData = (props, prevProps, step) => {
  try {
    spendData(
      document.getElementById('leadid_token').value || 'debug_mode_no_lead_id',
      props.affid && +props.affid !== 0 ? props.affid : localStorage.getItem('affidASR') || 0,
      props.siteID,
      props.uuid,
      props.urlParams.user_agent,
      props.urlParams.s1,
      props.urlParams.s2,
      props.ip,
      step,
    );
  } catch (e) {
    console.error(e);
  }
};

function getPixelParams(pixels) {
  try {
    if (Array.isArray(pixels)) {
      return pixels.map((pixel) => getPixelParams(pixel));
    }
    if (typeof pixels === 'string') {
      const regexExp = /#(.+?)#/g;
      const matches = [];
      let found = regexExp.exec(pixels);
      while (found !== null) {
        matches.push(found[1]);
        found = regexExp.exec(pixels);
      }
      return matches;
    }
  } catch (e) {
    console.error(e);
  }
  return [];
}

export function replaceTokensInLink(link, props) {
  const anchors = getPixelParams(link);
  let replaced = link;
  anchors.forEach((anchor) => {
    replaced = (hasProperty.call(props, anchor)
      || hasProperty.call(props.urlParams, anchor))
      ? replaced.replace(`#${anchor}#`, props[anchor] || props.urlParams[anchor]) : replaced;
  });
  return replaced;
}

export const firePixelsByLocation = (pixels, location, step, props, pixelType = 'js_script') => {
  const totalPixels = [];
  pixels.forEach((pixel) => {
    let toPlace;
    const withTokensReplaced = replaceTokensInLink(b64DecodeUnicode(pixel), props);
    const frag = new DOMParser().parseFromString(withTokensReplaced, 'text/html');
    const scripts = fixScriptsSoTheyAreExecuted(frag);
    if (pixelType === 'img') {
      const div = document.createElement('div');
      div.style = 'width: 1px; height: 1px; opacity: 0';
      div.innerHTML = withTokensReplaced;
      document.getElementsByTagName(location)[0].appendChild(div);
    } else if (pixelType === 'iframe') {
      const iframes = createIframes(frag);
      toPlace = [...scripts, ...iframes];
    } else {
      toPlace = [...scripts];
    }

    if (toPlace) {
      toPlace.forEach((scriptPixel) => {
        if (!props.debug) {
          document.getElementsByTagName(location)[0].appendChild(scriptPixel);
        }
      });
    }
    totalPixels.push(JSON.stringify(withTokensReplaced));
  });
  return totalPixels;
};

export async function getHash(message) {
  if (!window.crypto || !window.crypto.subtle) {
    return SHA256(message);
  }
  const data = encode(message);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
  return hashHex;
}

export const placeTaboolaFor550 = () => {
  try {
    const fixedScript = document.createElement('script');
    fixedScript.type = 'text/javascript';
    fixedScript.innerHTML = "window._tfa = window._tfa || []; window._tfa.push({notify: 'event', name: 'page_view', id: 1162145}); !function (t, f, a, x) { if (!document.getElementById(x)) { t.async = 1;t.src = a;t.id=x;f.parentNode.insertBefore(t, f); } }(document.createElement('script'), document.getElementsByTagName('script')[0], '//cdn.taboola.com/libtrc/unip/1162145/tfa.js', 'tb_tfa_script');";
    const fixedNoScript = document.createElement('noscript');
    const imgNode = document.createElement('img');
    imgNode.src = '//trc.taboola.com/1162145/log/3/unip?en=page_view';
    imgNode.width = 0;
    imgNode.height = 0;
    imgNode.setAttribute('style', 'display:none;');
    fixedNoScript.appendChild(imgNode);
    document.getElementsByTagName('head')[0].appendChild(fixedScript);
    document.getElementsByTagName('head')[0].appendChild(fixedNoScript);
  } catch (e) {
    console.error(e);
  }
};

const returnBlockIfDefined = (block, condition) => {
  try {
    return condition ? block : undefined;
  } catch {
    return undefined;
  }
};

const filterForDefinedKeys = (objectKey) => {
  try {
    return objectKey ? objectKey.value : undefined;
  } catch {
    return undefined;
  }
};

const formatSessionDate = (DOB) => {
  if (!filterForDefinedKeys(DOB)) {
    return undefined;
  }
  const parsedDate = (dob) => parse(dob || '01-01-2000', 'MM-dd-yyyy', new Date());
  return format(new Date(parsedDate(DOB.value)), 'yyyy/MM/dd')
    ? format(new Date(parsedDate(DOB.value)), 'yyyy/MM/dd')
    : DOB.value;
};

export const addToLocalStorageObject = (storageName, newObject) => {
  const storageValue = localStorage.getItem(storageName) || JSON.stringify({});
  localStorage.setItem(storageName, JSON.stringify({ ...JSON.parse(storageValue), ...newObject }));
};

export function buildMASession(formState) {
  const iterableVehicleState = formState.vehicleState
    ? Object.keys(formState.vehicleState).map((key) => formState.vehicleState[key])
    : false;
  const iterableDriverState = formState.driverState
    ? Object.keys(formState.driverState).map((key) => formState.driverState[key])
    : false;
  const carToDrivers = iterableVehicleState
    ? iterableVehicleState.map((vehicle, index) => {
      let driverIdx = '-1';
      iterableDriverState.forEach((driver, key) => {
        if (filterForDefinedKeys(driver.primaryVehicle) === String(index + 1)) {
          driverIdx = key + 1;
        }
      });
      return driverIdx;
    })
    : [];
  const firstVehicle = formState.vehicleState
    ? Object.keys(formState.vehicleState).sort((a, b) => a - b)[0]
    : undefined;
  const coverageLevel = formState.vehicleState
    ? filterForDefinedKeys(formState.vehicleState[firstVehicle.toString()].coverageDesired)
    : undefined;
  const firstDriver = Object.keys(formState.driverState).sort((a, b) => a - b)[0];
  const creditRating = filterForDefinedKeys(formState.driverState[firstDriver].creditRating);

  addToLocalStorageObject(
    'tyTitleOptions',
    {
      firstName: filterForDefinedKeys(firstDriver.firstName),
      lastName: filterForDefinedKeys(firstDriver.lastName),
      city: filterForDefinedKeys(formState.contact.city),
      state: filterForDefinedKeys(formState.contact.state),
    },
  );

  const result = {
    data: {
      vehicleCount: filterForDefinedKeys(formState.vehicleCount),
      lead_id: {
        lead_id: formState.lead_id || document.getElementById('leadid_token').value || 'debug_mode_no_lead_id',
        trustform_url: formState.trustedForm || (!!document.getElementById('xxTrustedFormToken_0') && document.getElementById('xxTrustedFormToken_0').value) || 'debug_mode_no_trusted_form',
      },
      drivers: iterableDriverState
        ? {
          ...iterableDriverState.map((driver, idx) => ({
            relationship: idx > 0 ? filterForDefinedKeys(driver.primaryRelationship) : 'self',
            driver_first_name: filterForDefinedKeys(driver.firstName),
            driver_last_name: filterForDefinedKeys(driver.lastName),
            gender: filterForDefinedKeys(driver.gender),
            marital_status: filterForDefinedKeys(driver.maritalStatus),
            married: filterForDefinedKeys(driver.maritalStatus),
            birth_date: formatSessionDate(driver.DOB),
            first_licensed: 18,
            education: 'unknown',
            primary_vehicle: iterableDriverState.length > 1 ? filterForDefinedKeys(driver.primaryVehicle) : '1',
            primary_car: iterableDriverState.length > 1 ? filterForDefinedKeys(driver.primaryVehicle) : '1',
            license_state: filterForDefinedKeys(formState.contact.state),
            credit_rating: creditRating,
          })),
        }
        : undefined,
      vehicles: iterableVehicleState
        ? {
          ...iterableVehicleState.map((vehicle, idx) => ({
            year: filterForDefinedKeys(vehicle.year),
            make: filterForDefinedKeys(vehicle.make),
            model: filterForDefinedKeys(vehicle.model),
            submodel: filterForDefinedKeys(vehicle.trim) ? filterForDefinedKeys(vehicle.trim).split('_')[0] : undefined,
            vin: filterForDefinedKeys(vehicle.trim) ? filterForDefinedKeys(vehicle.trim).split('_')[1] : undefined,
            alarm: '1',
            car_alarm: '1',
            primary_purpose: 'commute work',
            average_mileage: '15',
            commute_days_per_week: '5',
            annual_mileage: '12000',
            primary_driver: iterableDriverState && iterableDriverState.length > 1 ? carToDrivers[idx] : '1',
            ownership: 'own',
            collision: '0',
            comprehensive: '0',
          })),
        }
        : undefined,
      contact: formState.contact
        ? {
          0: {
            zip: filterForDefinedKeys(formState.contact.zipCode),
            email: filterForDefinedKeys(formState.contact.email),
            telephone: filterForDefinedKeys(formState.contact.phone),
            address: filterForDefinedKeys(formState.contact.streetAddress),
            city: filterForDefinedKeys(formState.contact.city),
            state: filterForDefinedKeys(formState.contact.state),
            home_ownership: filterForDefinedKeys(formState.driverState[1].homeOwner) ? '1' : '0',
            interested_in_home_insurance: filterForDefinedKeys(formState.coreg.bundleHomeInsurance) ? '1' : '0',
            home_length: filterForDefinedKeys(formState.contact.lengthOfHomeOwnership),
            phone_consent: '1',
            property_type: filterForDefinedKeys(formState.coreg.dwellingType),
          },
        }
        : undefined,
      coverage: formState.coverage
        ? {
          0: {
            currently_insured:
              !!filterForDefinedKeys(formState.coverage.currentInsuranceCarrier)
              && !Number.isInteger(
                Number.parseInt(
                  filterForDefinedKeys(
                    formState.coverage.currentInsuranceCarrier,
                  ),
                  10,
                ),
              )
                ? 1
                : 0,
            current_company: filterForDefinedKeys(formState.coverage.currentInsuranceCarrier),
            continuous_coverage: filterForDefinedKeys(formState.coverage.lengthOfInsurances),
            current_customer: '6',
            current_policy_expires: filterForDefinedKeys(formState.coverage.policyExpiration),
            bi_per_person: (coverageLevel === 'State Minimum' && '25000') || (coverageLevel === 'Standard Protection' && '100000') || (coverageLevel === 'Superior Protection' && '250000'),
            bi_per_incident: (coverageLevel === 'State Minimum' && '50000') || (coverageLevel === 'Standard Protection' && '300000') || (coverageLevel === 'Superior Protection' && '500000'),
            coverage_level: coverageLevel,
          },
        }
        : undefined,
    },
  };
  return result;
}

export function buildPartialAutoMASession(formState) {
  const iterableVehicleState = formState.vehicleState
    ? Object.keys(formState.vehicleState).map((key) => formState.vehicleState[key])
    : false;
  const iterableDriverState = formState.driverState
    ? Object.keys(formState.driverState).map((key) => formState.driverState[key])
    : false;
  const carToDrivers = iterableVehicleState
    ? iterableVehicleState.map((vehicle, index) => {
      let driverIdx = '-1';
      iterableDriverState.forEach((driver, key) => {
        if (filterForDefinedKeys(driver.primaryVehicle) === String(index + 1)) {
          driverIdx = key + 1;
        }
      });
      return driverIdx;
    })
    : [];
  const firstVehicle = formState.vehicleState
    ? Object.keys(formState.vehicleState).sort((a, b) => a - b)[0]
    : undefined;
  const coverageLevel = formState.vehicleState
    ? filterForDefinedKeys(formState.vehicleState[firstVehicle.toString()].coverageDesired)
    : undefined;
  const firstDriver = Object.keys(formState.driverState).sort((a, b) => a - b)[0];
  const creditRating = filterForDefinedKeys(formState.driverState[firstDriver].creditRating);

  addToLocalStorageObject(
    'tyTitleOptions',
    {
      firstName: filterForDefinedKeys(firstDriver.firstName),
      lastName: filterForDefinedKeys(firstDriver.lastName),
      city: filterForDefinedKeys(formState.contact.city),
      state: filterForDefinedKeys(formState.contact.state),
    },
  );

  const result = {
    data: {
      vehicleCount: filterForDefinedKeys(formState.vehicleCount),
      lead_id: {
        lead_id: formState.lead_id || document.getElementById('leadid_token').value || 'debug_mode_no_lead_id',
        trustform_url: formState.trustedForm || (!!document.getElementById('xxTrustedFormToken_0') && document.getElementById('xxTrustedFormToken_0').value) || 'debug_mode_no_trusted_form',
      },
      drivers: iterableDriverState
        ? {
          ...iterableDriverState.map((driver, idx) => ({
            relationship: idx > 0 ? filterForDefinedKeys(driver.primaryRelationship) : 'self',
            driver_first_name: filterForDefinedKeys(driver.firstName),
            driver_last_name: filterForDefinedKeys(driver.lastName),
            gender: filterForDefinedKeys(driver.gender),
            marital_status: filterForDefinedKeys(driver.maritalStatus),
            married: filterForDefinedKeys(driver.maritalStatus),
            birth_date: formatSessionDate(driver.DOB),
            primary_vehicle: returnBlockIfDefined(iterableDriverState && iterableDriverState.length > 1 ? filterForDefinedKeys(driver.primaryVehicle) : '1', driver.primaryVehicle),
            primary_car: returnBlockIfDefined(iterableDriverState && iterableDriverState.length > 1 ? filterForDefinedKeys(driver.primaryVehicle) : '1', driver.primaryVehicle),
            license_state: filterForDefinedKeys(formState.contact.state),
            credit_rating: creditRating,
          })),
        }
        : undefined,
      vehicles: iterableVehicleState
        ? {
          ...iterableVehicleState.map((vehicle, idx) => ({
            year: filterForDefinedKeys(vehicle.year),
            make: filterForDefinedKeys(vehicle.make),
            model: filterForDefinedKeys(vehicle.model),
            submodel: filterForDefinedKeys(vehicle.trim) ? filterForDefinedKeys(vehicle.trim).split('_')[0] : undefined,
            vin: filterForDefinedKeys(vehicle.trim) ? filterForDefinedKeys(vehicle.trim).split('_')[1] : undefined,
            primary_driver: iterableDriverState && iterableDriverState.length > 1 ? carToDrivers[idx] : '1',
          })),
        }
        : undefined,
      contact: formState.contact
        ? {
          0: {
            zip: filterForDefinedKeys(formState.contact.zipCode),
            email: filterForDefinedKeys(formState.contact.email),
            telephone: filterForDefinedKeys(formState.contact.phone),
            address: filterForDefinedKeys(formState.contact.streetAddress),
            city: filterForDefinedKeys(formState.contact.city),
            state: filterForDefinedKeys(formState.contact.state),
            home_ownership: returnBlockIfDefined(filterForDefinedKeys(formState.driverState[1].homeOwner) ? '1' : '0', formState.driverState[1].homeOwner),
            interested_in_home_insurance: returnBlockIfDefined(filterForDefinedKeys(formState.coreg.bundleHomeInsurance) ? '1' : '0', formState.coreg.bundleHomeInsurance),
            home_length: filterForDefinedKeys(formState.contact.lengthOfHomeOwnership),
            property_type: filterForDefinedKeys(formState.coreg.dwellingType),
          },
        }
        : undefined,
      coverage: formState.coverage
        ? {
          0: {
            currently_insured:
              !!filterForDefinedKeys(formState.coverage.currentInsuranceCarrier)
              && !Number.isInteger(
                Number.parseInt(
                  filterForDefinedKeys(
                    formState.coverage.currentInsuranceCarrier,
                  ),
                  10,
                ),
              )
                ? 1
                : 0,
            current_company: filterForDefinedKeys(formState.coverage.currentInsuranceCarrier),
            continuous_coverage: filterForDefinedKeys(formState.coverage.lengthOfInsurances),
            current_policy_expires: filterForDefinedKeys(formState.coverage.policyExpiration),
            coverage_level: coverageLevel,
          },
        }
        : undefined,
    },
  };
  return result;
}

export const buildSessionClicklistingHome = (formState) => {
  addToLocalStorageObject(
    'tyTitleOptions',
    {
      firstName: filterForDefinedKeys(formState.contact.firstName),
      lastName: filterForDefinedKeys(formState.contact.lastName),
      city: filterForDefinedKeys(formState.contact.city),
      state: filterForDefinedKeys(formState.contact.state),
    },
  );

  const tryNestedObject = (obj, key) => {
    try {
      if (obj && obj[key]) {
        return obj[key].value;
      }
      return false;
    } catch (e) {
      return false;
    }
  };
  return ({
    address: formState.contact.streetAddress.value,
    zip: formState.contact.zipCode.value,
    city: formState.contact.city.value,
    state: formState.contact.state.value,
    maritalStatus: formState.homeOwnerState.maritalStatus.value,
    gender: formState.homeOwnerState.gender.value,
    birthDate: formState.homeOwnerState.DOB.value,
    firstName: formState.contact.firstName.value,
    lastName: formState.contact.lastName.value,
    email: formState.contact.email.value,
    phoneNumber: formState.contact.phone.value,
    ownRent: formState.homeOwnerState.homeOwnership.value,
    currentlyInsured: !!formState.homeOwnerState.currentInsuranceCarrier.value && !Number
      .isInteger(Number.parseInt(formState.homeOwnerState.currentInsuranceCarrier.value, 10)) ? 1 : 0,
    currentInsurer: formState.homeOwnerState.currentInsuranceCarrier.value,
    homeType: formState.homeState.homeType.value,
    propertyType: formState.homeState.propertyType.value,
    stories: formState.homeState.stories.value,
    bathrooms: formState.homeState.bathrooms.value,
    bedrooms: formState.homeState.bedrooms.value,
    roof: formState.homeState.roofMaterial.value,
    securitySystem: formState.homeState.securitySystem.value,
    fireStation: formState.homeState.fireStation.value,
    fireHydrant: formState.homeState.fireHydrant.value,
    centralAir: formState.homeState.centralAir.value,
    deck: formState.homeState.deck.value,
    fireplace: formState.homeState.fireplace.value,
    attackDog: formState.homeState.attackDog.value,
    woodBurningStove: formState.homeState.woodBurningStove.value,
    inGroundPool: formState.homeState.inGroundPool.value,
    smoker: formState.homeState.smoker.value,
    sidingType: formState.homeState.sidingType.value,
    foundationType: formState.homeState.foundationType.value,
    yearBuilt: formState.homeState.yearBuilt.value,
    halfBathrooms: formState.homeState.halfBathrooms.value,
    sqFt: formState.homeState.squareFeet.value,
    garageType: formState.homeState.garageType.value,
    units: formState.homeState.units.value,
    deductible: formState.homeOwnerState.deductible.value,
    dwellingAmount: formState.homeOwnerState.dwellingAmount.value,
    personalPropertyCoverage: formState.homeOwnerState.personalPropertyCoverage.value,
    autoInterest: !!tryNestedObject(formState.coreg, 'bundleAuto'),
    lead_id: formState.lead_id,
    trustedForm: formState.trustedForm,
  });
};

export const buildSessionClicklistingHomeZipOnly = (formState) => {
  addToLocalStorageObject(
    'tyTitleOptions',
    {
      city: filterForDefinedKeys(formState.contact.city),
      state: filterForDefinedKeys(formState.contact.state),
    },
  );
  return ({
    zip: formState.contact.zipCode.value,
    city: formState.contact.city.value,
    state: formState.contact.state.value,
    lead_id: formState.lead_id,
    trustedForm: formState.trustedForm,
  });
};

export const buildSessionClicklistingLife = (formState) => {
  addToLocalStorageObject(
    'tyTitleOptions',
    {
      firstName: filterForDefinedKeys(formState.contact.firstName),
      lastName: filterForDefinedKeys(formState.contact.lastName),
      city: filterForDefinedKeys(formState.contact.city),
      state: filterForDefinedKeys(formState.contact.state),
    },
  );
  return ({
    firstName: formState.contact.firstName.value,
    lastName: formState.contact.lastName.value,
    address: formState.contact.address.value,
    city: formState.contact.city.value,
    state: formState.contact.state.value,
    zipCode: formState.contact.zipCode.value,
    email: formState.contact.email.value,
    gender: formState.contact.gender.value,
    DOB: formState.contact.DOB.value,
    phone: formState.contact.phone.value,
    maritalStatus: formState.contact.maritalStatus.value,
    hasChildren: formState.contact.hasChildren.value,
    youngestChildAge: formState.contact.youngestChildAge.value,
    ownsPets: formState.contact.ownsPets.value,
    currentlyEmployed: formState.contact.currentlyEmployed.value,
    height: formState.contact.height.value,
    weight: formState.contact.weight.value,
    currentlyInsured: formState.conditions.currentlyInsured.value,
    reasonForInsurance: formState.conditions.reasonForInsurance.value,
    usesTobacco: formState.conditions.usesTobacco.value,
    usesPrescriptions: formState.conditions.usesPrescriptions.value,
    medicalConditions: formState.conditions.medicalConditions.value,
    hospitalizedForAnxietyDepressionBipolar: formState.conditions.hospitalizedForAnxietyDepressionBipolar.value,
    coverageTerm: formState.conditions.coverageTerm.value,
    coverageAmount: formState.conditions.coverageAmount.value,
    coverageType: formState.conditions.coverageType.value,
    lead_id: formState.lead_id,
  });
};
